import { SearchApiParams } from '../../api';
import { RootSelector, getStore } from '../../reducers';
import { SearchShape } from './model';
import { createSelector } from '@reduxjs/toolkit';

export const getSearch: RootSelector<SearchShape> = createSelector(
  getStore,
  (state) => state.search,
);

export const getSearchText: RootSelector<string> = createSelector(
  getSearch,
  (search) => search.text,
);

export const getSearchUploadData = createSelector(getSearch, (search) => search.uploadData);

export const getSimilarAsset = createSelector(getSearch, (search) => search.similarAsset);

export const getSearchOptions = createSelector(getSearch, (search) => search.options);

export const getSearchApiParams = createSelector(
  [getSearchText, getSearchOptions, getSearchUploadData],
  (text, options, uploadData) => {
    const result: SearchApiParams = {};

    if (text) {
      result.search = text;
    }

    if (uploadData) {
      result.search_upload_id = uploadData.id;
    } else if (options.searchWithAi) {
      result.search_with_ai = 'true';
    } else {
      if (options.searchInLayers) {
        result.search_in_layers = 'true';
      }
      if (options.searchInArchives) {
        result.search_in_archives = 'true';
      }
    }

    return result;
  },
);
